
export const isHKIDFormat=(str)=> {
  if(!str) return false;
  var hkidPat = /^([A-Z]{1,2})([0-9]{6})\(([A0-9])\)$/;
  var matchArray = str.match(hkidPat);
  // not match, return false
  if (matchArray == null)
  return false;
  return true;
}